import React, { useState, useEffect, useRef } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import { API_URL } from '../Config';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import $ from 'jquery';
import 'datatables.net-bs5';
import Swal from 'sweetalert2';
import config from "../common/Config";
import { Link } from 'react-router-dom';
import { setTableWidths, getTableWidths } from "../../data/postAPi";


const PickingList = () => {
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [newSales, setNewSales] = useState([]);
  const [draw, setDraw] = useState(1);
  const [start, setStart] = useState(0);
  const [length, setLength] = useState(50);
  const [colWidths, setColWidths] = useState([120, 120, 120, 200, 150, 150, 50]);
  const userId = localStorage.getItem("userId");
  const tableName = "pickingListTable";
  function debounce(func, wait) {
    let timeout;
    return function (...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }
  const debouncedSetTableWidths = useRef(
    debounce((userId, tableName, widths) => {
      setTableWidths(userId, tableName, widths);
    }, 500)
  ).current;
  const tableRef = useRef(null);
  const startResizing = (index, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startWidth = colWidths[index];
    const onMouseMove = (moveEvent) => {
      const newWidth = Math.max(50, startWidth + moveEvent.clientX - startX);
      setColWidths((widths) => {
        const updated = [...widths];
        updated[index] = newWidth;
        debouncedSetTableWidths(userId, tableName, updated);
        return updated;
      });
    };
    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  useEffect(() => {
    async function fetchWidths() {
      try {
        const res = await getTableWidths(userId, tableName);
        if (res?.data?.widths && Array.isArray(res.data.widths) && res.data.widths.length > 0) {
          setColWidths(res.data.widths);
        } else {
          setColWidths([120, 120, 120, 200, 150, 150, 50]);
        }
      } catch (e) {
        setColWidths([120, 120, 120, 200, 150, 150, 50]);
      }
    }
    fetchWidths();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchData();
  };

  const fetchData = async () => {
    const formData = new FormData();
    formData.append('searchByFromdate', fromDate);
    formData.append('searchByTodate', toDate);
    formData.append('draw', draw);
    formData.append('start', start);
    formData.append('length', length);
    formData.append('role', selectedRole);

    const accessToken = localStorage.getItem('accessToken');
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    const apiUrl = `${API_URL}/picking/list`;
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to fetch new sales data');
      }

      const data = await response.json();
      setNewSales(Array.isArray(data.data) ? data.data : []);
    } catch (error) {
      console.error('Error fetching new sales data:', error);
    }
  };

  const deletePicking = async (picklistNumber) => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken === null) {
      window.location.href = `${config.BASE_URL}/login`;
      return;
    }

    // Create FormData object
    const formData = new FormData();
    formData.append('picklist_number', picklistNumber);

    try {
      const response = await fetch(`${API_URL}/remove_picklist`, {
        method: 'POST',
        headers: {
          'authorization': `Bearer ${accessToken}`,
          // Note: FormData automatically sets Content-Type to multipart/form-data
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Failed to delete picking item');
      }

      await response.json();
      fetchData();
      Swal.fire('Deleted!', 'Your picking item has been deleted.', 'success');
    } catch (error) {
      console.error('Error deleting picking item:', error);
      Swal.fire('Error!', 'There was an error deleting the item.', 'error');
    }
  };


  const confirmDelete = async (picklistNumber) => {
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (result.isConfirmed) {
      deletePicking(picklistNumber);
      Swal.fire('Deleted!', 'Your picking item has been deleted.', 'success');
    }
  };

  useEffect(() => {
    fetchData();
  }, [fromDate, toDate, selectedRole]);

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if ($.fn.DataTable.isDataTable('#neworderTable')) {
      $('#neworderTable').DataTable().destroy();
    }
    const table = $('#neworderTable').DataTable({
      paging: true,
      lengthMenu: [10, 20, 50],
      searching: true,
      ordering: false,
      pageLength: 50,
      info: true,
      responsive: false,
      autoWidth: false,
      language: {
        paginate: {
          first: 'First',
          last: 'Last',
          next: 'Next',
          previous: 'Previous',
        },
        search: 'Search:',
      },
      data: newSales,
      columns: [
        {
          data: 'picklist_number',
          width: colWidths[0] + 'px',
          className: 'text-center',
          render: (data, type, row) => {
            if (accessToken == 'tss' || accessToken == 'tsc') {
              return `<a href="${config.BASE_URL}/sales/single_view_picking_list/${row.picklist_number}">${row.picklist_number}</a>`;
            } else {
              return `<a href="${config.BASE_URL}/sales/view_picking_list/${row.picklist_number}">${row.picklist_number}</a>`;
            }
          }
        },
        { data: 'total_sales_count', width: colWidths[1] + 'px' },
        { data: 'route_name', width: colWidths[2] + 'px', className: 'text-center' },
        { data: 'name', width: colWidths[3] + 'px' },
        { data: 'print_on', width: colWidths[4] + 'px', className: 'text-center' },
        { data: 'picking_status', width: colWidths[5] + 'px', className: 'text-center' },
        {
          data: null,
          width: colWidths[6] + 'px',
          render: function (data, type, row) {
            if(row.is_lock == 0){
              return `<div>
                <a class="deductionbtn" href="edit_picking/${row.picklist_number}" title="Edit" ><i class="bi bi-pencil-square"></i></a>
                <a href="#"  class="applybtn" onclick="handleDelete('${row.picklist_number}')" title="Delete"><i class="bi bi-trash"></i></a>
                </div>`;
            }else{
              return `<span></span>`
            }
          },
        },
      ],
    });
    window.handleDelete = confirmDelete;
    const addResizerListeners = () => {
      const resizers = document.querySelectorAll('#neworderTable .th-resizer');
      resizers.forEach((resizer, index) => {
        const handleMouseDown = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          startResizing(index, e);
        };
        resizer.addEventListener('mousedown', handleMouseDown);
        resizer._resizerHandler = handleMouseDown;
      });
    };
    const timeoutId = setTimeout(() => {
      addResizerListeners();
      $('#neworderTable thead th').each(function(idx) {
        $(this).css('width', colWidths[idx] + 'px');
      });
    }, 100);
    return () => {
      clearTimeout(timeoutId);
      const resizers = document.querySelectorAll('#neworderTable .th-resizer');
      resizers.forEach((resizer) => {
        if (resizer._resizerHandler) {
          resizer.removeEventListener('mousedown', resizer._resizerHandler);
        }
      });
      if ($.fn.DataTable.isDataTable('#neworderTable')) {
        table.destroy();
      }
      window.handleDelete = null;
    };
  }, [newSales]);

  useEffect(() => {
    const styleSheet = document.createElement('style');
    styleSheet.textContent = `.th-resizer:hover { background-color: rgba(0, 0, 0, 0.3) !important; } .resizable-header { position: relative; user-select: none; }`;
    document.head.appendChild(styleSheet);
    return () => {
      if (document.head.contains(styleSheet)) {
        document.head.removeChild(styleSheet);
      }
    };
  }, []);

  return (
    <div>
      <Header />
      <nav className="breadcrumbs">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">
              <a href="#"><i className="fa fa-home"></i> </a>
              <span className="last-crumb">Picking List</span>
            </div>
          </div>
        </div>
      </nav>
      <div className="main-container">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 col-lg-12 col-sm-12">


              <div className='dashboard picking-list-table'>
                {/* <div style={{ float: 'right', width: '100%', textAlign: 'right', marginTop: '25px' }}>

                  </div> */}


                <div className="verical-scrl-wrapper picking-list" id="style-3">
                  <table className="table table-bordered dataTable resizable resizable-columns" id="neworderTable" ref={tableRef}>
                    <thead>
                      <tr>
                        {["Picklist No", "Invoices", "Route Name", "Picker", "Picklist Date", "Picking Status", "Action"].map((header, idx) => (
                          <th
                            key={header}
                            className="resizable-header"
                            style={{
                              width: colWidths[idx],
                              minWidth: 50,
                              position: "relative",
                              padding: "8px"
                            }}
                          >
                            {header}
                            {idx < colWidths.length - 1 && (
                              <div
                                className="th-resizer"
                                data-column-index={idx}
                                title="Drag to resize column"
                                style={{
                                  position: 'absolute',
                                  right: '-2px',
                                  top: 0,
                                  width: '5px',
                                  height: '100%',
                                  cursor: 'col-resize',
                                  zIndex: 999,
                                  userSelect: 'none'
                                }}
                              />
                            )}
                          </th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* DataTables will handle rendering of rows */}
                    </tbody>
                  </table>
                </div>


              </div>

            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PickingList;
